import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { FC, useState } from 'react';
import { RemovedBackendApplication } from '@/types/backend';

type DeletedApplicationDialogProps = {
  open: boolean;
  deletedApplications: RemovedBackendApplication[];
  onSelect: (applicationId: string) => void;
  onClose: () => void;
};

const columns = [
  { field: 'label', headerName: 'Label', flex: 1 },
  { field: 'removedDate', headerName: 'Removed date', flex: 1 },
  { field: 'removedBy', headerName: 'Removed by', flex: 1 }
];

const DeletedApplicationDialog: FC<DeletedApplicationDialogProps> = (props) => {
  const [selectedApplicationId, setSelectedApplicationId] = useState<string>('');

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Previously deleted applications</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <DataGrid
          rows={props.deletedApplications?.map((app) => {
            return {
              id: app.applicationId,
              label: app.label,
              removedDate: app.removed && new Date(app.removed).toDateString(),
              removedBy: app.removedBy?.loginName
            };
          })}
          columns={columns}
          onRowClick={(application) => setSelectedApplicationId(application.row.id)}
          autoHeight
          hideFooter
          sx={{
            width: '100%',
            //Disables cell outlines in datagrid.
            [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
              outline: 'none'
            },
            [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
              outline: 'none'
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={() => props.onSelect(selectedApplicationId)} color='primary'>
          Restore
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletedApplicationDialog;
